/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
import { authService } from '@/services';
import i18n from '@/i18n';
import get from 'lodash/get';

const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
const LOGIN_FAILED = 'LOGIN_FAILED';
const LOGOUT = 'LOGOUT';
const TOKEN_FAILED = 'TOKEN_FAILED';
const TOKEN_SUCCESS = 'TOKEN_SUCCESS';
const GETUSERINFO_SUCCESS = 'GETUSERINFO_SUCCESS';
const SERVER_TIME = 'SERVER_TIME';
const LOST_SUCCESS = 'LOST_SUCCESS';
const LOST_FAILED = 'LOST_FAILED';

export const state = {
  isAuth: false,
  userInfo: null,
  serverTime: null,
  tokenFailed: false,
};

export const getters = {
  isAuth: state => state.isAuth,
  tokenFailed: state => state.tokenFailed,
  userInfo: state => get(state, ['userInfo']) || {},
  individual: state => get(state, ['userInfo', 'individual']) || {},
  username: state => localStorage.getItem('camillo_username') || null, // è chiamato email ma si tratta dello username
  serverTime: state =>
    (state.serverTime ? state.serverTime.current_server_time.split(' ') : []),
  name: state =>
    `${get(state, ['userInfo', 'individual', 'name']) || ''} ${get(state, [
      'userInfo',
      'individual',
      'surname',
    ]) || ''}`,
  showContact: state =>
    (get(state, ['userInfo', 'individual'])
      ? !!get(state, ['userInfo', 'individual']).show_contacts
      : false),
};

export const actions = {
  init({ state, dispatch }) {
    state.isAuth = false;
    state.userInfo = null;
    state.serverTime = null;
    state.tokenFailed = false;
  },
  async getUserInfo({ commit, dispatch }) {
    const user = await authService.getUserInfo();
    if (user.individual) {
      commit(GETUSERINFO_SUCCESS, user);
    } else {
      try {
        const response = await authService.profile();
        commit(GETUSERINFO_SUCCESS, response.data.data);
      } catch (error) {
        dispatch(
          'notificationService',
          { type: 'error', text: error },
          { root: true },
        );
      }
    }
  },
  async updateUserInfo({ commit, dispatch }, { user }) {
    try {
      await authService.updateProfile(user);
      const response = await authService.profile();
      commit(GETUSERINFO_SUCCESS, response.data.data);
      i18n.locale = user.language;
      localStorage.setItem('language', user.language);
    } catch (error) {
      dispatch(
        'notificationService',
        { type: 'error', text: error },
        { root: true },
      );
    }
  },
  login({ dispatch, commit }, { username, password }) {
    authService.login(username, password).then(
      (response) => {
        commit(LOGIN_SUCCESS, response);
        dispatch('getUserInfo');
      },
      (error) => {
        commit(LOGIN_FAILED, error);
        dispatch(
          'notificationService',
          { type: 'error', text: i18n.t('all.error_wrong_credentials') },
          { root: true },
        );
      },
    );
  },
  logout({ commit }) {
    authService.logout();
    commit(LOGOUT);
  },
  checkToken({ commit }, { token }) {
    authService.checkToken(token).then(
      (response) => {
        commit(TOKEN_SUCCESS, response);
      },
      (error) => {
        commit(TOKEN_FAILED, error);
      },
    );
  },
  lostPassword({ commit, dispatch }, username) {
    authService.lostPassword(username).then(
      (response) => {
        commit(LOST_SUCCESS, response);
      },
      (error) => {
        dispatch(
          'notificationService',
          { type: 'error', text: error },
          { root: true },
        );
        commit(LOST_FAILED, error);
      },
    );
  },
  resetPassword({ commit, dispatch }, { password, token }) {
    authService.resetPassword(password, token).then(
      (response) => {
        commit(LOST_SUCCESS, response);
      },
      (error) => {
        dispatch(
          'notificationService',
          { type: 'error', text: error },
          { root: true },
        );
        commit(LOST_FAILED, error);
      },
    );
  },
  getServerTime({ commit, dispatch }) {
    authService
      .getServerTime()
      .then((response) => {
        commit(SERVER_TIME, response);
      })
      .catch((error) => {
        dispatch(
          'notificationService',
          { type: 'error', text: error },
          { root: true },
        );
      });
  },
};

export const mutations = {
  [GETUSERINFO_SUCCESS](state, data) {
    state.userInfo = data;
    const objDest = JSON.parse(localStorage.getItem('user'));
    Object.assign(objDest.userInfo.data, data);
    localStorage.setItem('user', JSON.stringify(objDest));
    if (data && data.email) {
      localStorage.setItem('camillo_username', data.email);
    }
  },
  [LOGIN_FAILED](state) {
    state.isAuth = false;
  },
  [LOGOUT](state) {
    state.isAuth = false;
  },
  [TOKEN_SUCCESS](state, el) {
    state.tokenFailed = false;
  },
  [TOKEN_FAILED](state, el) {
    state.tokenFailed = true;
  },
  [LOGIN_SUCCESS](state, el) {
    state.isAuth = authService.isAuthorized;
  },
  [LOST_SUCCESS](state, el) {
    state.isAuth = false;
  },
  [LOST_FAILED](state, el) {
    state.isAuth = false;
  },
  [SERVER_TIME](state, el) {
    state.serverTime = el;
  },
};
